export const SOMETHING_WRONG = 'Something went wrong';
export const CHANGES_CONFLICT = 'The changes you have made have not been saved because another administrator has made changes to the objects you are trying to save. Please try again.';